import React, { useState } from "react";

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What SEO offerings do you offer?",
      answer: "We offer complete search engine marketing services inclusive of on-page search engine optimization, off-web page search engine optimization, technical search engine marketing, local search engine optimization, and e-trade SEO to enhance website rating, site visitors, and standard on line visibility.",
    },
    {
      question: "How long does SEO take to expose outcomes?",
      answer: "Search engine marketing is a protracted-time period strategy. Generally, it takes 3 to six months to peer substantive upgrades in scores, traffic, and leads relying on opposition and industry.",
    },
    {
      question: "Do you offer SEO offerings for small organizations?",
      answer: "Yes, we specialise in search engine marketing offerings for small groups with low cost plans designed to improve visibility, attract local customers, and generate regular leads.",
    },
    {
      question: "Why is technical SEO important?",
      answer: "Technical search engine marketing ensures your internet site is rapid, cellular-friendly, and clean to crawl with the aid of search engines, which helps enhance indexing, rankings, and common internet site overall performance.",
    },
    {
      question: "What makes your SEO offerings one-of-a-kind?",
      answer: "Our search engine optimization services focus on consequences, the use of white-hat strategies, custom designed strategies, and everyday reporting to improve rankings, force traffic, and growth conversions.",
    },

  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="k-faq-section">
      <div className="k-faq-container">
        <h2 className="k-faq-heading">Frequently Asked Questions</h2>

        {faqData.map((item, index) => (
          <div
            key={index}
            className={
              activeIndex === index ? "k-faq-box active" : "k-faq-box"
            }
          >
            <div
              className="k-faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span className="k-faq-title">{item.question}</span>
              <span className="k-faq-arrow">
                {activeIndex === index ? "▲" : "▼"}
              </span>
            </div>

            <div className="k-faq-answer">
              <p className="k-faq-text">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;